<template>
    <card-expandable
        v-if="props.chat.emails.length > 0"
        toggle-color="gray-100"
        is-opened-at-start
        with-collapse-arrow
        with-content
    >
        <text-decorator :size="Size.xs">
            Verzonden e-mails
        </text-decorator>

        <template #content>
            <flex-container
                gap="sm"
            >
                <flex-container
                    v-for="email in props.chat.emails"
                    :key="email.id.value"
                >
                    <button-text
                        style="overflow: hidden"
                        @click="openModal(email)"
                    >
                        <text-decorator
                            :title="email.subject"
                            style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap"
                            size="xs"
                        >
                            {{ email.subject }}
                        </text-decorator>
                        <div>
                            <svg-icon
                                :icon="ChevronRightIcon"
                                :size="IconSize.xs"
                                is-custom-icon
                            />
                        </div>
                    </button-text>
                </flex-container>
            </flex-container>

            <email-content-dialog
                v-if="selectedEmail"
                ref="emailDialog"
                :email="selectedEmail"
            />
        </template>
    </card-expandable>
</template>

<script setup lang="ts">
    import { nextTick, ref } from 'vue';
    import { type ExposedOverlay, IconSize, Size } from '@keyvue/one-ui';
    import type { Chat, ChatEmail } from '@keyvue/one-api-client';
    import ChevronRightIcon from '@keyvue/one-awesome-icons/icons/regular/chevron-right.svg?component';
    import EmailContentDialog from '@/ai/assistent/components/dialog/EmailContentDialog.vue';

    const props = defineProps<{ chat: Chat }>();
    const emailDialog = ref<{ overlay: ExposedOverlay }>();
    const selectedEmail = ref<ChatEmail>();

    async function openModal(email: ChatEmail) {
        selectedEmail.value = email;

        // Other fix could be setting a default value for email
        // Otherwise would brake because email-content-dialog component needs to be rendered first because of the v-if
        await nextTick();
        emailDialog.value?.overlay.openOverlay();
    }
</script>
